import(/* webpackMode: "eager" */ "/home/runner/_work/compass-ui/compass-ui/apps/marketplace/src/app/global-error.tsx");
